interface Props {
  className?: string;
}

export default function BankRouting({ className }: Props) {
  return (
    <svg
      className={`dark:text-text-dark text-text-light ${className}`}
      fill='none'
      height='14'
      viewBox='0 0 12 14'
      width='12'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path clipRule='evenodd' d='M0.0131836 3.19141H4.24141V10.8022H0.0131836V3.19141Z' fill='currentColor' />
      <path
        clipRule='evenodd'
        d='M6.77832 0.65625H11.0065V4.88448H6.77832V0.65625Z'
        fill='currentColor'
        fillRule='evenodd'
      />
      <path
        clipRule='evenodd'
        d='M6.77832 9.11328H11.0065V13.3415H6.77832V9.11328Z'
        fill='currentColor'
        fillRule='evenodd'
      />
    </svg>
  );
}
